import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { OAUTH_REQUEST_TYPE } from '../common/handleApiCall';
import _ from 'lodash';

//- Actions
export const fetchCheckOAuthRequestParamsFailed = createAction('FETCH_CHECK_OAUTH_REQUEST_PARAMS_FAILED');
export const fetchCheckOAuthRequestParamsSuccess = createAction('FETCH_CHECK_OAUTH_REQUEST_PARAMS_SUCCESS');
export const fetchCheckOAuthRequestParams = createAction(
    'FETCH_CHECK_OAUTH_REQUEST_PARAMS',
    (params) => Api.checkOAuthRequest(params),
    () => ({
        apiCall: true,
        onSuccess: fetchCheckOAuthRequestParamsSuccess,
        onFail: fetchCheckOAuthRequestParamsFailed,
        type: OAUTH_REQUEST_TYPE
    })
);

export const fetchOAuthGiveAccessFailed = createAction('FETCH_OAUTH_GIVE_ACCESS_FAILED');
export const fetchOAuthGiveAccessSuccess = createAction('FETCH_OAUTH_GIVE_ACCESS_SUCCESS');
export const fetchOAuthGiveAccess = createAction(
    'FETCH_OAUTH_GIVE_ACCESS',
    (data) => Api.sendOAuthGiveAccess(data),
    () => ({
        apiCall: true,
        onSuccess: fetchOAuthGiveAccessSuccess,
        onFail: fetchOAuthGiveAccessFailed,
        type: OAUTH_REQUEST_TYPE
    })
);

//- State
const initialState = {
    requestData: null,
    dataToRedirect: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_CHECK_OAUTH_REQUEST_PARAMS: (state) => {
        return { ...state, requestData: null, error: null, fetching: true };
    },
    FETCH_CHECK_OAUTH_REQUEST_PARAMS_FAILED: (state, action) => {
        return { ...state, requestData: null, error: action.payload, fetching: false };
    },
    FETCH_CHECK_OAUTH_REQUEST_PARAMS_SUCCESS: (state, action) => {
        return { ...state, requestData: action.payload, error: null, fetching: false };
    },
    FETCH_OAUTH_GIVE_ACCESS: (state) => {
        return { ...state, dataToRedirect: null, error: null, fetching: true };
    },
    FETCH_OAUTH_GIVE_ACCESS_FAILED: (state, action) => {
        return { ...state, dataToRedirect: null, error: action.payload, fetching: false };
    },
    FETCH_OAUTH_GIVE_ACCESS_SUCCESS: (state, action) => {
        return { ...state, dataToRedirect: action.payload, error: null, fetching: false };
    }

}, initialState);

//- Selectors
export const getOAuth = state => state.oauth;

export const getOAuthDataToRedirect = state => getOAuth(state).dataToRedirect;

export const getOAuthRedirectTo = state => {
    let requestData = getOAuthClientData(state);
    let dataToRedirect = getOAuthDataToRedirect(state);

    if (!_.isNil(requestData) && requestData.redirectTo) {
        return requestData.redirectTo;
    }
    if (!_.isNil(dataToRedirect) && dataToRedirect.redirectTo) {
        return dataToRedirect.redirectTo;
    }

    return null;
}

export const getOAuthLoading = state => getOAuth(state).fetching;

export const getOAuthError = state => getOAuth(state).error;

export const getOAuthClientData = state => getOAuth(state).requestData;


// WEBPACK FOOTER //
// ./src/reducers/oauth/oauth.js